import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import Button from "Components/Button.js";

const RaildaysStatusPage = ({
	title,
	code,
	message,
	primaryActionLabel = "Back to home",
	primaryActionTo = "/"
}) => (
	<Container maxWidth="lg" sx={{py: {xs: 4, md: 6}}}>
		<Box
			sx={{
				backgroundColor: "#fff",
				borderRadius: 2,
				p: {xs: 4, md: 6},
				textAlign: "center",
				boxShadow: 2
			}}>
			<Stack spacing={2} alignItems="center">
				<Box
					component="img"
					alt="Raildays logo"
					src="/assets/Raildays/brand/logo.svg"
					sx={{height: 48}} />
				{code && (
					<Typography variant="h3" sx={{fontWeight: 800, color: "#e2b534"}}>
						{code}
					</Typography>
				)}
				<Typography variant="h5" sx={{fontWeight: 700}}>
					{title}
				</Typography>
				{message && (
					<Typography color="text.secondary" sx={{maxWidth: 560}}>
						{message}
					</Typography>
				)}
				<Button label={primaryActionLabel} uri={primaryActionTo} variant="contained" />
			</Stack>
		</Box>
	</Container>
);

export default RaildaysStatusPage;
